import React from 'react'

import InputGroup from '../../atoms/InputGroup'
import Loading from '../../atoms/Loading'

export default class RadioButtonGroup extends React.PureComponent {
  static defaultProps = {
    items: [],
    loading: false,
    onChange: null,
    value: null,
    name: undefined
  }

  handleRadioClick(value) {
    if (this.props.value !== value) {            
      this.props.onChange(value)
    }
  }

  handleRadioClickMemoizedFunctions = {}
  getMemoizedHandleRadioClick = (value) => {
    if (this.handleRadioClickMemoizedFunctions[value]) {
      return this.handleRadioClickMemoizedFunctions[value]
    }

    return this.handleRadioClickMemoizedFunctions[value] = () => {
      this.handleRadioClick(value)
    }
  }

  getRadioName() {
    if(this.props.name !== undefined && this.props.name.length > 0) {
      return this.props.name;
    }
    else {
      return "radio" + crypto.randomUUID().split('-')[0];
    }
  }

  render() {
    if (this.props.loading) {
      return <Loading />
    }

    return (
      <InputGroup
        className={ this.props.className }
        items={ this.props.items }
      >
        {(item) => (
          <input
            type="radio"
            name={ this.getRadioName() }
            checked={ this.props.value === item.value }
            onClick={ this.getMemoizedHandleRadioClick(item.value) }
            value={ item.value }
          />
        )}
      </InputGroup>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/molecules/RadioButtonGroup/RadioButtonGroup.js